/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Jobs_ProvidedInputs */

const en_no_jobs_provided = /** @type {(inputs: No_Jobs_ProvidedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No jobs provided.`)
};

const de_no_jobs_provided = /** @type {(inputs: No_Jobs_ProvidedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Jobs angegeben.`)
};

/**
* | output |
* | --- |
* | "No jobs provided." |
*
* @param {No_Jobs_ProvidedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_jobs_provided = /** @type {((inputs?: No_Jobs_ProvidedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Jobs_ProvidedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_jobs_provided(inputs)
	return en_no_jobs_provided(inputs)
});